module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/franchising/support.09904295f04a667ac342fba8a2a67666.jpg";